import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-container-xxl q-col-md-6 q-offset-md-3 q-mt-3 q-mb-3" }
const _hoisted_2 = { class: "smartsearch-serp__input-group-container q-input-group q-input-group" }

import SearchInput from '@/components/SearchInput.vue'





export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInputContainer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SearchInput, { autocomplete: false })
    ])
  ]))
}
}

})